'use client';

import { SparklesIcon, Cancel01Icon } from '@terra/ui-icons';
import { Toast } from '@terra/ui-design-system';
import { Box, HStack, VStack } from '@terra/ui-styled-system';
import { Text } from '@terra/ui-design-system';
import { IconButton } from '@terra/ui-design-system';

type CopilotSessionToastProps = {
  toastId: string;
  title: string;
  brandLabel: string;
  statusLabel: string;
  closeLabel: string;
  onOpen?: () => void;
};

export function CopilotSessionToast({
  toastId,
  title,
  brandLabel,
  statusLabel,
  closeLabel,
  onOpen,
}: CopilotSessionToastProps) {
  return (
    <Toast.Root
      key={toastId}
      maxW="260px"
      p="2"
      bg="bg.canvas"
      borderWidth="1px"
      borderColor="border.subtle"
      borderRadius="md"
      boxShadow="sm"
    >
      <VStack gap="1.5" alignItems="stretch" w="full">
        <HStack gap="2" alignItems="center" justifyContent="space-between">
          <HStack gap="1.5" alignItems="center" minW="0">
            <Box
              display="inline-flex"
              alignItems="center"
              justifyContent="center"
              w="5"
              h="5"
              borderRadius="sm"
              bg="terra.a2"
              color="terra.11"
              flexShrink={0}
            >
              <SparklesIcon size={12} />
            </Box>
            <Text
              fontSize="2xs"
              fontWeight="semibold"
              color="terra.11"
              truncate
            >
              {brandLabel}
            </Text>
          </HStack>
          <Toast.CloseTrigger asChild>
            <IconButton size="xs" variant="link" aria-label={closeLabel}>
              <Cancel01Icon size={12} />
            </IconButton>
          </Toast.CloseTrigger>
        </HStack>
        <Box
          as="button"
          display="flex"
          alignItems="center"
          gap="2"
          w="full"
          minW="0"
          p="0"
          bg="transparent"
          border="none"
          cursor={onOpen ? 'pointer' : 'default'}
          textAlign="left"
          onClick={onOpen}
        >
          <Text
            as="span"
            display="inline-flex"
            alignItems="center"
            minW="0"
            flex="1"
            px="1.5"
            py="0.5"
            borderRadius="sm"
            bg="terra.a1"
            border="1px solid"
            borderColor="terra.a3"
            fontSize="xs"
            fontWeight="medium"
            color="terra.11"
            truncate
            _hover={
              onOpen ? { bg: 'terra.a2', borderColor: 'terra.a4' } : undefined
            }
          >
            {title}
          </Text>
          <Text fontSize="2xs" color="fg.muted" flexShrink={0}>
            {statusLabel}
          </Text>
        </Box>
      </VStack>
    </Toast.Root>
  );
}
